import { render, staticRenderFns } from "./KLIcon.vue?vue&type=template&id=79633e4f&scoped=true"
import script from "./KLIcon.vue?vue&type=script&lang=js"
export * from "./KLIcon.vue?vue&type=script&lang=js"
import style0 from "./KLIcon.vue?vue&type=style&index=0&id=79633e4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79633e4f",
  null
  
)

export default component.exports